var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315.76,
    height: 315.755,
    viewBox: "0 0 83.545 83.544",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cd553b",
      fillOpacity: 1,
      stroke: "#042d82",
      strokeWidth: 3.96875,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M72.182 61.483 45.657 76.73 16.12 68.758.87 42.234l7.973-29.538L35.37-2.552 64.906 5.42l15.249 26.524Z",
    transform: "translate(1.26 4.682)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cd553b",
      fillOpacity: 1,
      stroke: "#317ec4",
      strokeWidth: 4.09622,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m51.543 74.41 67.445-38.749M65.579 98.855l67.445-38.749",
    transform: "translate(-50.522 -25.56)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a1710f6fca435d9f6a805ad7f931610f.svg";
export { ForwardRef as ReactComponent };